import { render, staticRenderFns } from "./webschool.vue?vue&type=template&id=5914ab8c&scoped=true"
import script from "./webschool.vue?vue&type=script&lang=js"
export * from "./webschool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914ab8c",
  null
  
)

export default component.exports